import React from 'react';
import OrdersList from '../../../../orders/general/list';
import { Stack } from '@fluentui/react';

interface IVendorOrdersListProps {
    vendorId: string;
}

const VendorOrdersList: React.FC<IVendorOrdersListProps> = ({ vendorId }) => {
    return (
        <Stack tokens={{ childrenGap: 10 }}>
            <OrdersList
                qs={[`vendor_id=${vendorId}`]}
                hideCreateOrder={true}
                variant="plain"
            />
        </Stack>
    );
};

export default VendorOrdersList;
